import styled from 'styled-components';

export const Login = styled.form`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 16px;
  margin-top: 48px;
  max-width: 320px;
`;
